import loading from '/asset/loading.gif';
interface LoadingProps {
  text?: string;
}
const Loading: React.FC<LoadingProps> = ({ text }) => {
  return (
    <div className="w-full h-[100px]">
      <img
        src={loading}
        className="m-auto w-[50px] 
        object-contain"
      />
      <div
        className="font-dmsans m-auto font-[400] 
        text-center text-[14px] mt-[5px]"
      >
        {text ? text : 'Loading'}
      </div>
    </div>
  );
};

export default Loading;
